/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HotelSummary } from './HotelSummary';
import {
    HotelSummaryFromJSON,
    HotelSummaryFromJSONTyped,
    HotelSummaryToJSON,
    HotelSummaryToJSONTyped,
} from './HotelSummary';
import type { HotelTheme } from './HotelTheme';
import {
    HotelThemeFromJSON,
    HotelThemeFromJSONTyped,
    HotelThemeToJSON,
    HotelThemeToJSONTyped,
} from './HotelTheme';
import type { Viewport } from './Viewport';
import {
    ViewportFromJSON,
    ViewportFromJSONTyped,
    ViewportToJSON,
    ViewportToJSONTyped,
} from './Viewport';
import type { TransferPartner } from './TransferPartner';
import {
    TransferPartnerFromJSON,
    TransferPartnerFromJSONTyped,
    TransferPartnerToJSON,
    TransferPartnerToJSONTyped,
} from './TransferPartner';

/**
 * Terminal event when all batches have arrived. Carries the
 * aggregated search-level metadata AND the canonical hotel list.
 * Per-batch `hotels` events emit raw items (un-enriched) for fast
 * progressive render; `complete.items` carries the same list with
 * gondola_recommended + tag enrichment applied so the SSE client
 * ends up with the same view as a polling client.
 * 
 * @export
 * @interface SearchStreamComplete
 */
export interface SearchStreamComplete {
    /**
     * 
     * @type {string}
     * @memberof SearchStreamComplete
     */
    type: SearchStreamCompleteTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SearchStreamComplete
     */
    totalItems: number;
    /**
     * Aggregated + enriched hotel list (deduped across batches,
     * tags applied, gondola_recommended populated). Equivalent to
     * the polling endpoint's final response.
     * 
     * @type {Array<HotelSummary>}
     * @memberof SearchStreamComplete
     */
    items?: Array<HotelSummary>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchStreamComplete
     */
    availableAmenities?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchStreamComplete
     */
    availableImageCategories?: Array<string>;
    /**
     * 
     * @type {Array<HotelTheme>}
     * @memberof SearchStreamComplete
     */
    availableHotelThemes?: Array<HotelTheme>;
    /**
     * 
     * @type {Array<TransferPartner>}
     * @memberof SearchStreamComplete
     */
    availableTransferPartners?: Array<TransferPartner>;
    /**
     * 
     * @type {Viewport}
     * @memberof SearchStreamComplete
     */
    recommendedViewport?: Viewport;
    /**
     * 
     * @type {Viewport}
     * @memberof SearchStreamComplete
     */
    searchRegion?: Viewport;
}


/**
 * @export
 */
export const SearchStreamCompleteTypeEnum = {
    Complete: 'complete'
} as const;
export type SearchStreamCompleteTypeEnum = typeof SearchStreamCompleteTypeEnum[keyof typeof SearchStreamCompleteTypeEnum];


/**
 * Check if a given object implements the SearchStreamComplete interface.
 */
export function instanceOfSearchStreamComplete(value: object): value is SearchStreamComplete {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('totalItems' in value) || value['totalItems'] === undefined) return false;
    return true;
}

export function SearchStreamCompleteFromJSON(json: any): SearchStreamComplete {
    return SearchStreamCompleteFromJSONTyped(json, false);
}

export function SearchStreamCompleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchStreamComplete {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'totalItems': json['total_items'],
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(HotelSummaryFromJSON)),
        'availableAmenities': json['available_amenities'] == null ? undefined : json['available_amenities'],
        'availableImageCategories': json['available_image_categories'] == null ? undefined : json['available_image_categories'],
        'availableHotelThemes': json['available_hotel_themes'] == null ? undefined : ((json['available_hotel_themes'] as Array<any>).map(HotelThemeFromJSON)),
        'availableTransferPartners': json['available_transfer_partners'] == null ? undefined : ((json['available_transfer_partners'] as Array<any>).map(TransferPartnerFromJSON)),
        'recommendedViewport': json['recommended_viewport'] == null ? undefined : ViewportFromJSON(json['recommended_viewport']),
        'searchRegion': json['search_region'] == null ? undefined : ViewportFromJSON(json['search_region']),
    };
}

export function SearchStreamCompleteToJSON(json: any): SearchStreamComplete {
    return SearchStreamCompleteToJSONTyped(json, false);
}

export function SearchStreamCompleteToJSONTyped(value?: SearchStreamComplete | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'total_items': value['totalItems'],
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(HotelSummaryToJSON)),
        'available_amenities': value['availableAmenities'],
        'available_image_categories': value['availableImageCategories'],
        'available_hotel_themes': value['availableHotelThemes'] == null ? undefined : ((value['availableHotelThemes'] as Array<any>).map(HotelThemeToJSON)),
        'available_transfer_partners': value['availableTransferPartners'] == null ? undefined : ((value['availableTransferPartners'] as Array<any>).map(TransferPartnerToJSON)),
        'recommended_viewport': ViewportToJSON(value['recommendedViewport']),
        'search_region': ViewportToJSON(value['searchRegion']),
    };
}

